.dealQualifiedContainer {
  padding: 24px;
  background: var(--colors-grays-white);
  border: 1px solid var(--colors-grays-ultralight);
  border-radius: var(--border-radius-lg);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  box-shadow:
    0px 2px 16px 0px rgb(0 0 0 / 5%),
    0px 0px 0px 1px rgb(0 0 0 / 5%);
}

.dealQualifiedButtons {
  display: flex;
  gap: 24px;
  flex-direction: column-reverse;
  justify-content: center;
  width: 100%;
}

.dealQualifiedButton {
  width: 100%;
}

@media all and (--reefer-media-tablet-min) {
  .dealQualifiedContainer {
    box-shadow: none;
  }

  .dealQualifiedButtons {
    flex-direction: row;
  }

  .dealQualifiedButton {
    width: 200px;
  }
}
